import {
    SET_CLOSED_BATCHES,
    UPDATE_CLOSED_BATCH,
    SELECT_CLOSED_BATCH,
    ACTIVATE_CLOSED_BATCH,
} from '../actions/types';

const initialClosedBatchesState = {
    closedBatches: [],
    upcomingClosedBatches: [],
    selectedClosedBatch: null,
};

const closedBatches = (
    state = initialClosedBatchesState,
    { payload, type }
) => {
    switch (type) {
        case SET_CLOSED_BATCHES:
            return {
                ...state,
                closedBatches: payload.active,
                upcomingClosedBatches: payload.upcoming,
            };
        case UPDATE_CLOSED_BATCH:
            return {
                ...state,
                closedBatches: state.closedBatches.map(batch =>
                    batch.LotId === payload.LotId
                        ? {
                              ...batch,
                              ...payload,
                              loadingSummary: !batch.loadingSummary,
                          }
                        : batch
                ),
            };
        case SELECT_CLOSED_BATCH:
            return { ...state, selectedClosedBatch: payload };
        case ACTIVATE_CLOSED_BATCH:
            const newClosedBatchesState = state.upcomingClosedBatches.reduce(
                (acc, curr) =>
                    curr.LotId === payload
                        ? {
                              ...acc,
                              closedBatches: [...acc.closedBatches, curr],
                          }
                        : {
                              ...acc,
                              upcomingClosedBatches: [
                                  ...acc.upcomingClosedBatches,
                                  curr,
                              ],
                          },
                {
                    closedBatches: [...state.closedBatches],
                    upcomingClosedBatches: [],
                }
            );
            return {
                ...state,
                closedBatches: newClosedBatchesState.closedBatches,
                upcomingClosedBatches:
                    newClosedBatchesState.upcomingClosedBatches,
            };
        default:
            return state;
    }
};

export default closedBatches;
